export function getFieldAlias(dataSource, field) {

    // Console logging flag
    const logToConsole = false;

    // NOTE: used for 3rd try
    const fieldLength = field !== null ? field.length : 0;
    // console.log(' > Length: {0}'.format(fieldLength));

    // Lookup the aliases
    let alias = null;

    for (let s = 0; s < dataSource.fields.length; s++) {

        let dataSourceField = null;
        if (typeof dataSource.fields[s] === "object") {
            dataSourceField = dataSource.fields[s].name;
        } else {
            dataSourceField = dataSource.fields[s];
        }
        // console.log(' > Datasource Field: {0}'.format(dataSourceField));

        // NOTE: 3rd try:
        const dataSourceFieldParts = dataSourceField.split(" ");
        const dataSourceFieldLastPart = dataSourceFieldParts.slice(-1)[0];
        const dataSourceFieldLastPartLength = dataSourceFieldLastPart.length;
        // console.log('   - Last Part: {0} ({1})'.format(dataSourceFieldLastPart, dataSourceFieldLastPartLength));

        if (dataSourceField.indexOf(field) >= 0 && fieldLength === dataSourceFieldLastPartLength) {

            if (typeof dataSource.fields[s] === "object") {
                alias = dataSource.fields[s].alias;
            } else {
                alias = dataSource.aliases[s];
            }

            break;
        }
    }

    // console.log('ALIAS: {0}'.format(alias));
    // if (!alias) {
    //     console.log("**ERROR** Invalid Configuration for {0} (Missing alias for {1})".format(dataSource.name, field));
    // }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c getFieldAlias', 'font-weight: bold; color: none',
            '\n' + ' - dataSource.typeof:', typeof dataSource,
            '\n' + ' - field.typeof:', typeof field,
            '\n' + ' - alias.typeof:', typeof alias + '\n',
            { dataSource },
            { field },
            { alias }
        );
    }

    return alias;
}

export function getFieldFormatters(dataSource, field) {

    // Console logging flag
    const logToConsole = false;

    // NOTE: used for 3rd try
    const fieldLength = field.length;
    // console.log(' > Length: {0}'.format(fieldLength));

    // Lookup the field index
    let formatters = [];

    for (let s = 0; s < dataSource.fields.length; s++) {

        let dataSourceField = null;
        if (typeof dataSource.fields[s] === "object") {
            dataSourceField = dataSource.fields[s].name;
        } else {
            dataSourceField = dataSource.fields[s];
        }
        // console.log(' > Datasource Field: {0}'.format(dataSourceField));

        // NOTE: 3rd try:
        const dataSourceFieldParts = dataSourceField.split(" ");
        const dataSourceFieldLastPart = dataSourceFieldParts.slice(-1)[0];
        const dataSourceFieldLastPartLength = dataSourceFieldLastPart.length;
        // console.log('   - Last Part: {0} ({1})'.format(dataSourceFieldLastPart, dataSourceFieldLastPartLength));

        if (dataSourceField.indexOf(field) >= 0 && fieldLength === dataSourceFieldLastPartLength) {

            if (typeof dataSource.fields[s] === "object") {
                formatters = dataSource.fields[s].formatters;
            } else {
                formatters = s !== -1 ? dataSource.formatters[s] : [];
            }

            break;

        // NOTE: 2nd try: includes() was added to accommodate for aliased field names
        // and will probably break at some point ... and it broke
        // if (fieldName.indexOf(field) >= 0 || fieldName.includes(field)) {
        //     fieldIndex = s;
        //     break;
        // }

        // NOTE: 1st try:
        // if (fieldName.indexOf(field) >= 0) {
        //     fieldIndex = s;
        //     break;
        }
    }

    // console.log('FORMATTERS: ', formatters);
    // if (!formatters) {
    //     console.log("**ERROR** Invalid Configuration for {0} (Missing formatters for {1})".format(dataSource.name, field));
    // }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c getFieldFormatters', 'font-weight: bold; color: none',
            '\n' + ' - dataSource.typeof:', typeof dataSource,
            '\n' + ' - field.typeof:', typeof field,
            '\n' + ' - formatters.typeof:', typeof formatters + '\n',
            { dataSource },
            { field },
            { formatters }
        );
    }

    return formatters;
}

export function getFieldValue(dataSource, field) {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c getFieldValue', 'font-weight: bold; color: none',
            '\n' + ' - dataSource.typeof:', typeof dataSource,
            '\n' + ' - field.typeof:', typeof field + '\n',
            { dataSource },
            { field }
        );
    }

    if (dataSource.data && dataSource.data.length === 1) {
        if (dataSource.data[0].hasOwnProperty(field)){
            return dataSource.data[0][field];
        }
    }

    return null;
}

export function areLoadDependenciesMet(dependencies, filters) {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c areLoadDependenciesMet', 'font-weight: bold; color: none',
            '\n' + ' - dependencies.typeof:', typeof dependencies,
            '\n' + ' - filters.typeof:', typeof filters + '\n',
            { dependencies },
            { filters }
        );
    }

    // Return true if there are no dependancies
    if (!dependencies)
        return true;
    if (!dependencies.load)
        return true;

    // Handle Load/Filter dependencies
    const loadFilterDependencies = dependencies.load.filter(l => l.type.toLowerCase() === 'filter');

    let metConditions = 0;
    for (let f = 0; f < filters.length; f++) {
        for (let c = 0; c < loadFilterDependencies.length; c++ ){
            if (filters[f].id.toLowerCase() === loadFilterDependencies[c].id.toLowerCase()){
                metConditions++;
                break;
            }
        }
    }

    if (metConditions === loadFilterDependencies.length){
        return true;
    } else {
        return false;
    }

}
